import "./styles.css";
import logo from "./CarmenLandsLogo.png";
import { useEffect, useRef, useState } from "react";

import { WavyLink } from "react-wavy-transitions";

export const Navbar6 = () => {
  const lastScrollTop = useRef(0);
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);

  useEffect(() => {
    let timeoutId; // Variable para almacenar el ID del timeout

    const handleScroll = () => {
      clearTimeout(timeoutId); // Limpiar el timeout anterior
      var { pageYOffset } = window;

      if (pageYOffset > lastScrollTop.current) {
        // downward scroll
        setIsNavbarVisible(false);
      } else if (pageYOffset < lastScrollTop.current) {
        // upward scroll
        setIsNavbarVisible(false);
      } // else was horizontal scroll

      lastScrollTop.current = pageYOffset <= 0 ? 0 : pageYOffset;

      // Comprobar si la barra de navegación ya está en su posición normal en la parte superior
      if (pageYOffset <= 0) {
        setIsNavbarVisible(true); // Mantener la barra visible
      } else {
        // Configurar un nuevo timeout para ocultar la barra de navegación después de 1500ms (1.5 segundos)
        timeoutId = setTimeout(() => {
          setIsNavbarVisible(false);
        }, 1500);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // Limpieza del efecto
    return () => {
      clearTimeout(timeoutId); // Limpiar el timeout al desmontar el componente
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [isNavbarVisible2, setIsNavbarVisible2] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible2(!isNavbarVisible2);
  };

  

  return (
    <nav id="nav6" className={`navbar ${isNavbarVisible ? "visible" : ""}`}>
      <img src={logo} alt="Logo" />
      <button className="menu-toggle" onClick={toggleNavbar}>
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div className={`nav-items ${isNavbarVisible2 ? "visible" : ""}`}>
        <ul>
          <li>
            <div>
              <button id="nav-contact">
                <a href="/">¡Soy Carmen!</a>
              </button>
            </div>
          </li>
          <li>
            <WavyLink direction="up" to="/tienda" color="#45db52">
              Tienda
            </WavyLink>
          </li>

          {/* 
          <li className="nav-item-badge">
            <span className="badge-novedad3">Novedades</span>

            <WavyLink direction="up" to="/tienda/mint-by-michelle" color="#6aee75">
              Mint by Michelle
            </WavyLink>
          </li>
          */}
          <li className="nav-item-badge">
             <span className="badge-novedad3">Novedades</span> 

            <WavyLink direction="up" to="/tienda/cadence" color="#4593db">
              Cadence
            </WavyLink>
          </li>
          <li className="nav-item-badge">
            {/* Badge de novedad */}
            {/*<span className="badge-novedad2">Nuevo</span>*/}

            <WavyLink direction="up" to="/tienda/montejo" color="#dbac45ff">
              Montejo
            </WavyLink>
          </li>
          <li className="nav-item-badge">
            {/* Badge de novedad */}
            {/*<span className="badge-novedad2">Nuevo</span>*/}

            <WavyLink direction="up" to="/tienda/papers-for-you" color="#de95e7ff">
              Papers For You
            </WavyLink>
          </li>
          <li className="nav-item-badge">
            {/* Badge de novedad */}
            {/*<span className="badge-novedad2">Nuevo</span>*/}

            <WavyLink direction="up" to="/tienda/rossi" color="#aa6934ff">
              Rossi
            </WavyLink>
          </li>
          <li>
            <WavyLink direction="up" to="/tienda/muebles-ornamentos" color="#db4545">
              Muebles y Ornamentos
            </WavyLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};
